<template>
  <div>

    <HeaderPersonal />

    <div class="section color mid-line">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container last form two w-container">

        <div v-if="haveNewRequest" class="form-regidet profil w-form">
          <div style="align-items: center;" class="w-layout-vflex flex-form">
            <h1 class="heading-form text-center" style="margin-bottom: 15px">Подтверждение заявки</h1>
            <p class="text-center" style="margin-bottom: 25px">Проверьте данные ниже и подтвердите данные</p>
          </div>
        </div>

        <!-- Личные данные -->
        <div class="form-regidet profil w-form">
          <form id="wf-form-signup-2" name="wf-form-signup-2" data-name="signup" method="get" data-ms-form="signup" class="form-input-regidet" data-wf-page-id="6667fc8089ed7ce9f6a63d6e" data-wf-element-id="be470ab5-17a8-9531-d725-c70c94a6ea13">
            <v-form ref="formProfile" v-model="valid_profile" lazy-validation>
              <div class="tittle-form profil" style="margin-bottom: 15px;">
                <h1 class="heading-form">Личные данные</h1>
                <a v-if="!isRedactProfile" @click="redactProfile" class="item-edit w-inline-block">
                  <div class="text-classic-link link">Редактировать</div>
                  <img src="../../../../../public/images/Edit.svg" loading="lazy" alt="" class="icon-edit">
                </a>
                <a v-else @click="cancelRedactProfile" class="item-edit w-inline-block">
                  <div class="text-classic-link link">Отмена</div>
                  <img src="../../../../../public/images/close.svg" loading="lazy" alt="" class="icon-edit">
                </a>
              </div>
              <div class="w-layout-vflex flex-form">
                <div class="w-layout-hflex flex-input">
                  <div class="input-box">
                    <label for="Phone-2" class="input-label">Телефон</label>
                    <input
                        v-model="profile_data.phone"
                        disabled
                        class="input-form w-input"
                        maxlength="256"
                        name="Phone-2"
                        inputmode="numeric"
                        data-name="Phone 2"
                        type="tel"
                        id="Phone-2"
                        required="">
                  </div>
<!--                  <div class="input-box">-->
<!--                    <div v-if="!isRedactProfile">-->
<!--                      <label for="FIO-2" class="input-label">ФИО</label>-->
<!--                      <input-->
<!--                          v-model="profile_data.full_name"-->
<!--                          :disabled="!isRedactProfile || isRedactProfileSend"-->
<!--                          class="input-form w-input"-->
<!--                          maxlength="256"-->
<!--                          name="FIO-2"-->
<!--                          data-name="FIO 2"-->
<!--                          type="text"-->
<!--                          id="FIO-2"-->
<!--                          required="">-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
                <!-- v-if="isRedactProfile" -->
                <div class="w-layout-hflex flex-input">
<!--                  <div class="input-box input-error">-->
<!--                    <label for="SecondName-2" class="input-label">Фамилия</label>-->
<!--                    <v-text-field-->
<!--                        id="SecondName-2"-->
<!--                        name="SecondName-2"-->
<!--                        outlined-->
<!--                        v-model="profile_data.second_name"-->
<!--                        :rules="nameRules"-->
<!--                        :disabled="isRedactProfileSend"-->
<!--                    ></v-text-field>-->
<!--                  </div>-->
                  <div class="input-box">
                    <label for="Name-2" class="input-label">Имя</label>
                    <v-text-field
                        id="Name-2"
                        name="Name-2"
                        outlined
                        inputmode="text"
                        v-model="profile_data.name"
                        :rules="nameRules"
                        :disabled="isRedactProfileSend || !isRedactProfile"
                    ></v-text-field>
                  </div>

<!--                  <div class="input-box">-->
<!--                    <label for="MiddleName-3" class="input-label">Отчество</label>-->
<!--                    <v-text-field-->
<!--                        id="MiddleName-3"-->
<!--                        name="MiddleName-3"-->
<!--                        outlined-->
<!--                        inputmode="text"-->
<!--                        v-model="profile_data.middle_name"-->
<!--                        :rules="nameRules"-->
<!--                        :disabled="isRedactProfileSend"-->
<!--                    ></v-text-field>-->
<!--                  </div>-->
                </div>

                <div
                    class="w-layout-hflex flex-input"
                    v-if="isRedactProfile"
                >
                  <div class="input-box" style="display: flex;">
                    <a id="openLabel"
                       class="button-bust w-button"
                       :class="{ 'disable': isRedactProfileSend }"
                       @click="sendProfileChanges"
                    >
                      Отправить
                    </a>
                  </div>
                </div>
              </div>
            </v-form>
          </form>
        </div>

        <div v-if="haveNewRequest" class="form-regidet profil w-form">
          <div class="w-layout-vflex flex-form">
            <div
                class="w-layout-hflex flex-input"
            >
              <div class="input-box" style="display: flex;">
                <a
                   class="button-bust w-button"
                   @click="regDone"
                >
                  Оформить заявку
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import { Footer, HeaderPersonal } from '/src/app/shared/components';
import loadjs from 'loadjs';

export default {
  name: 'PersonalData',
  data() {
    return {
      isRedactProfile: false,
      copyProfileData: {},

      isRedactProfileSend: false,

      valid_profile: false,

      dateRules: [
        v => !!v || 'Введите корректную дату',
        v => this.isValidDate(v) || 'Неправильный формат даты'
      ],
      nameRules: [
        v => !!v || 'Поле не может быть пустым',
        v => (v && v.length <= 256) || 'Максимальная длина 256 символов'
      ],
    };
  },
  components: {
    Footer,
    HeaderPersonal
  },
  computed: {
    haveNewRequest: {
      get() {
        return this.$store.getters.HAVE_NEW_REQUEST;
      },
      set(value) {
        this.$store.commit('SET_HAVE_NEW_REQUEST', value);
      }
    },
    profile_data() {
      console.log('profile_data');
      if (this.isRedactProfile) {
        console.log('is redact');
        return this.copyProfileData;
      } else {
        console.log('is not redact');
        return this.personal_data.profile;
      }
    },
    personal_data: {
      get() {
        return this.$store.getters.PERSONAL_DATA;
      },
      set(value) {
        this.$store.commit('SET_PERSONAL_DATA', value);
      }
    },
  },
  created() {
    this.$store.dispatch('GET_PERSONAL_DATA', 'all').catch({
      error: () => {
        this.$buefy.toast.open({
          message: 'Ошибка получения данных',
          type: 'is-danger'
        });
      }
    });
  },
  methods: {
    regDone() {
      // Получаем параметры из Vue Router
      const queryString = this.$router.resolve({
        path: '/',
        query: this.$route.query
      }).href.split('?')[1] || ''

      this.$router.push({
        path: '/',
        query: this.$route.query,
        replace: true
      }).then(() => {
        // Затем редирект на внешний сайт
        let url = `https://crapinka.ru/cXyjbhq7?aff_sub4=showcase${queryString ? `&${queryString}` : ''}`;
        console.log(url);
        window.open(url, '_blank');
      });
    },
    newRequest () {
      this.$router.push('/new-request');
    },
    cancelRedactProfile() {
      this.isRedactProfile = false;
      this.isRedactProfileSend = false;
    },

    sendProfileChanges() {
      if (this.$refs.formProfile.validate()) {
        this.isRedactProfileSend = true;

        this.$store.dispatch('CHANGE_PROFILE_DATA', this.profile_data)
            .then(() => {
              this.$buefy.toast.open({
                message: 'Сохранено!',
                type: 'is-success'
              });
            })
            .catch(() => {
              this.$buefy.toast.open({
                message: 'Ошибка сохранения',
                type: 'is-danger'
              });
            })
            .finally(() => {
              this.isRedactProfile = false;
              this.isRedactProfileSend = false;
            });
      } else {
        this.$buefy.toast.open({
          message: 'Неправильно заполнены поля',
          type: 'is-danger'
        });
      }
    },
    redactProfile() {
      this.isRedactProfile = true
      this.copyProfileData = JSON.parse(JSON.stringify(this.personal_data.profile));
      this.splitFullName(this.personal_data.profile.full_name, this.copyProfileData);
    },
    splitFullName(full_name, arr) {
      const parts = full_name.trim().split(/\s+/);

      arr.second_name = parts[0] || '';
      arr.name = parts[1] || '';
      arr.middle_name = parts[2] || '';
    },
    isValidDate(dateString) {
      // Проверка на пустую строку
      if (!dateString) return false;

      // Регулярное выражение для проверки формата YYYY-MM-DD
      const regEx = /^\d{4}-\d{2}-\d{2}$/;

      // Проверка соответствия формату
      if (!dateString.match(regEx)) return false;

      // Проверка, что дата валидна
      const d = new Date(dateString);
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const day = d.getDate();

      // Проверка на правильное количество дней в месяце
      if (year < 1000 || year > 9999 || month < 1 || month > 12) return false;
      const daysInMonth = new Date(year, month, 0).getDate();
      if (day < 1 || day > daysInMonth) return false;

      return true;
    },
    getWord(num){
      return "балл" + this.getNoun(num)
    },
    getNoun(number) {
      let n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return 'ов';
      }
      n %= 10;
      if (n === 1) {
        return '';
      }
      if (n >= 2 && n <= 4) {
        return 'а';
      }
      return 'ов';
    }
  },
  mounted() {
    /* грузим jquery и webflow */
    loadjs(
        "https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=652921c910bae02d8870dddf",
        {
          success: () => {
            loadjs('./js/webflow.js', {
              success: () => {
                console.log('Webflow loaded');
              },
              error: () => {
                console.error('Failed to load Webflow');
              }
            });
          },
          error: () => {
            console.error('Failed to load jQuery');
          }
        }
    );
  },
  beforeRouteLeave (to, from, next) {
    console.log('Чистим заявку');
    this.$store.commit("SET_HAVE_NEW_REQUEST", false);
    console.log('Почистили заявку');
    next();
  }
};
</script>

<style>
</style>
